export default {
  title: 'Importar menú',
  master_title: 'Modo marca - Importar menú',
  buttons: {
    import: 'Importar',
  },
  toasts: {
    import: {
      pending:
        '⏳La importación puede ser lenta, la realizamos en segundo plano. Por favor, revisa el menú del restaurante en unos minutos.',
    },
  },
};
